export enum IamPermissionSetAccessType {
  NO_ACCESS = 'no_access',
  READ = 'read',
  WRITE = 'write',
}

export enum RedirectionViews {
  DEFAULT = 'default',
  SASE = 'sase',
  SCM = 'scm',
  HYBRID = 'hybrid',
  SASE_CN = 'sase_cn',
  SCM_CN = 'scm_cn',
}

export enum BadgeType {
  VALUE = 'value',
  ICON = 'icon'
}
